import React from 'react';
import { Plus } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const SectionHeader = ({ icon: Icon, title, onAdd }) => {
    const { isDarkMode } = useTheme();

    return (
        <div className={`flex items-center justify-between mb-4 border-b pb-2 ${isDarkMode ? 'border-slate-700' : 'border-slate-100'}`}>
            <div className={`flex items-center gap-2 font-semibold ${isDarkMode ? 'text-slate-200' : 'text-slate-700'}`}>
                <Icon size={18} className={isDarkMode ? "text-blue-400" : "text-blue-600"} />
                <h3>{title}</h3>
            </div>
            {onAdd && (
                <button
                    onClick={onAdd}
                    className={`transition-colors ${isDarkMode ? 'text-slate-500 hover:text-blue-400' : 'text-slate-400 hover:text-blue-600'}`}
                    title="Add New Item"
                >
                    <Plus size={18} />
                </button>
            )}
        </div>
    );
};

export default SectionHeader;
